import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** Store下载组件属性接口 */
export interface StoreDownloadAttrs extends BaseComponentAttrs {
  /** 标题 */
  title?: string;
  /** 描述文本 */
  description?: string;
  /** Google Play 下载链接 */
  googleStore_url?: string;
  /** App Store 下载链接 */
  appleStore_url?: string;
}

/** Store下载组件类 */
export class StoreDownloadComponent extends BaseComponent<StoreDownloadAttrs> {
  constructor(data: Partial<BaseComponent<StoreDownloadAttrs>> = {}) {
    super(data);
    this.type = CompType.store_download;
  }

  /** 获取标题 */
  public getTitle(): string {
    return this.title || this.lang_attrs?.title || "";
  }

  /** 获取描述文本 */
  public getDescription(): string {
    return this.lang_attrs?.description || "";
  }

  /** 获取 Google Play 下载链接 */
  public getGooglePlayUrl(): string {
    return this.lang_attrs?.googleStore_url || "";
  }

  /** 获取 App Store 下载链接 */
  public getAppStoreUrl(): string {
    return this.lang_attrs?.appleStore_url || "";
  }
}
